/**
 * Redux-saga
 */
import { delay, put, takeEvery, call, select, takeLatest } from 'redux-saga/effects';

/**
 * Library
 */
import qs from 'qs';
import { AxiosResponse } from 'axios';

/**
 * Redux
 */
import { LibraryWaitingIdKeyObject, RootState } from 'redux/reducers/type';
import { CompareJobStatusAfterRequestLibraryListAction } from 'redux/actions/type';
import { COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST } from 'redux/actions/types';
import {
  compareJobStatusAfterRequestLibraryList,
  addWaitingLibraryJobId,
  deleteWaitingLibraryJobId,
} from 'redux/actions/actions';
import { enqueueSnackbarList } from 'redux/actions/actions';

/**
 * Framework
 */
import { getAPI, postAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import { throwError } from 'redux/actions/actions';

/**
 * VO
 */
import LibraryVO from 'commons/vo/Library';
import SnackbarNotification from 'commons/vo/SnackbarNotification';

/**
 * Constants
 */
import { Auth } from 'commons/constants/KeyFlowConstants';

const completedJobList = ['SUCCESS', 'FAILURE'];
const waitingJobList = ['WAITING', 'PROCEED'];

/**
 * DefaultFuction
 */
function* compareJobStatusAfterRequestLibraryListSaga(
  action: CompareJobStatusAfterRequestLibraryListAction,
) {
  const { param } = action.payload;
  try {
    const { waitingIdList } = yield select((state: RootState) => state.libraryNotification);
    // const { userId } = yield select((state: RootState) => state.user);
    const userId = localStorage.getItem(Auth.USER_ID) || 'anonymous';
    const waitingIdListByUserId = waitingIdList[userId] || {};

    const response: AxiosResponse = yield call(getAPI, API.LIBRARY, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: LibraryVO[] = keyFlowResponse.getResult(LibraryVO) as LibraryVO[];

    // Notification 을 실행하고 대기열에서 삭제할 리스트
    const deleteIdList: LibraryWaitingIdKeyObject = {};

    const notificationList = resultList
      .filter(library => completedJobList.includes(library.status as string))
      .filter(library => waitingIdListByUserId[library.id])
      .map(library => new SnackbarNotification({ library }));

    yield put(enqueueSnackbarList(notificationList));

    notificationList.forEach(notification => {
      deleteIdList[notification.jobId] = notification.status;
    });

    yield put(deleteWaitingLibraryJobId({ deleteIdList, userId }));

    // 새로운 대기 리스트 추가
    const addIdList: LibraryWaitingIdKeyObject = {};

    resultList
      .filter(library => waitingJobList.includes(library.status as string))
      .forEach(library => {
        addIdList[library.id] = library.status as KeyFlowLibraryStatus;
      });

    yield put(addWaitingLibraryJobId({ addIdList, userId }));
  } catch (error: any | Error) {
    console.error(error);
    yield put(throwError({ error }));
    // yield put(requestLibraryListFailure());
  }
}

export function* watchLibraryNotificationSaga() {
  yield takeEvery(
    COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST,
    compareJobStatusAfterRequestLibraryListSaga,
  );
}
